<template>
  <div class="navbar"></div>

  <section class="section skills">
    <div class="container">
      <h1 class="section-title">Skills</h1>

      <div class="skills-grid">
        <div v-for="skill in skills" :key="skill.name" class="card">
          <h4>{{ skill.name }}</h4>
          <i v-if="skill.icon" :class="[skill.icon, `colored`]"></i>
          <span v-else class="fallback-icon">{{ skill.fallback }}</span>
        </div>
      </div>
    </div>
  </section>

  <footer class="footer pt-5 pb-5 text-center"></footer>
</template>

<script>
export default {
  data() {
    return {
      skills: [
        { name: "Ruby", icon: "devicon-ruby-plain" },
        { name: "JavaScript", icon: "devicon-javascript-plain" },
        { name: "Ruby on Rails", icon: "devicon-rails-plain" },
        { name: "React", icon: "devicon-react-original" },
        { name: "Redux", icon: "devicon-redux-original" },
        { name: "Vue.js", icon: "devicon-vuejs-plain" },
        { name: "PostgreSQL", icon: "devicon-postgresql-plain" },
        { name: "Apache Kafka", icon: "devicon-apachekafka-original" },
        { name: "RSpec", icon: "devicon-rspec-plain" },
        { name: "REST APIs", icon: "fallback-icon" },
        { name: "JWT Auth", icon: "fallback-icon" },
        { name: "Git", icon: "devicon-git-plain" },
        { name: "GitHub", icon: "devicon-github-original" },
        { name: "GitHub Actions", icon: "fallback-icon" },
        { name: "Docker", icon: "devicon-docker-plain" },
        { name: "AWS", icon: "devicon-amazonwebservices-original" },
        { name: "HTML", icon: "devicon-html5-plain" },
        { name: "CSS", icon: "devicon-css3-plain" },
        { name: "Material UI", icon: "devicon-materialui-plain" },
        { name: "Bootstrap", icon: "devicon-bootstrap-plain" },
        { name: "Styled Components", icon: "fallback-icon" },
        { name: "npm", icon: "devicon-npm-original-wordmark" },
        { name: "Webpack", icon: "devicon-webpack-plain" },
      ],
    };
  },
};
</script>

<style scoped>
.navbar {
  background-color: transparent;
  color: #fff;
  height: 70px;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 40px;
}

.section-title {
  color: white;
  text-shadow: 1px 1px #a90084;
  font-weight: 800;
  line-height: 1.2;
  margin: 40px 0;
  text-align: center;
}

.skills-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.card {
  background-color: rgb(188, 255, 254);
  color: #333;
  border-radius: 10px;
  padding: 20px;
  width: 160px;
  min-height: 140px;
  text-align: center;
}

.card h4 {
  font-size: 20px;
  margin-bottom: 12px;
  line-height: 1.2;
  word-break: break-word;
}

.card i {
  font-size: 45px;
}

.fallback-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 18px;
  height: 42px;
  min-width: 42px;
  padding: 0 8px;
  border-radius: 8px;
}

@media (max-width: 500px) {
  .navbar {
    height: 100px;
  }

  .container {
    padding: 0 20px;
  }

  .card {
    width: 120px;
  }
}
</style>
